type Slot = {
  // 広告とdivのマッピングに使うID。任意の文字列でよい
  id: string;
  adUnitPath: string;
  sizes: Array<[number, number]>;
};

export const pcSlots: Slot[] = [
  {
    id: 'div-gpt-ad-1435135522823-4',
    adUnitPath: '/62539033/PCフッターパネル(左)',
    sizes: [[300, 250]],
  },
  {
    id: 'div-gpt-ad-1435135522823-3',
    adUnitPath: '/62539033/PCフッターパネル(右)',
    sizes: [[300, 250]],
  },
  {
    id: 'div-gpt-ad-1473215132261-0',
    adUnitPath: '/62539033/PCトップパネル(上)',
    sizes: [[300, 250]],
  },
];

export const spSlots: Slot[] = [];
